import { useMemo } from 'react';

import { type AddOnKey } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';

import { useFetchAnyPublicPermissions } from '~/hooks/useFetchAnyPublicPermissions';
import { usePublicLinkAddOns } from '~/swr-hooks/workspaces/addOns/usePublicLinkAddOns';
import { canViewAddOns } from '~/utils/permissions/workspacePermissions';

export const useCanViewPublicAddOn = ({ key }: { key: AddOnKey }) => {
  const { shortId } = useShortIdContext();
  const { data: permissions } = useFetchAnyPublicPermissions();
  const { data: addOns, isLoading } = usePublicLinkAddOns({ shortId, enabled: canViewAddOns(permissions) });

  const canViewAddOn = useMemo(
    () => !!addOns?.data.some((addOn) => addOn.key === key && addOn.enabled && addOn.visible),
    [key, addOns?.data],
  );

  return {
    canViewAddOn,
    isLoading,
  };
};
